import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header fixed z-50 w-full bg-black text-base" }
const _hoisted_2 = { class: "h-8 bg-black flex" }
const _hoisted_3 = { class: "w-3/5 text-white font-bold" }
const _hoisted_4 = { class: "float-left ml-4 mt-1 text-xl" }
const _hoisted_5 = { class: "w-2/5" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "pr-4 mt-1" }
const _hoisted_8 = { class: "flex h-14" }
const _hoisted_9 = { class: "w-3/5 pt-4" }
const _hoisted_10 = { class: "header-text float-left w-1/3 text-white" }
const _hoisted_11 = { class: "header-text float-left w-1/3 text-white" }
const _hoisted_12 = { class: "header-text float-left w-1/3 text-white" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"header-logo mr-2 inline-flex w-2/5 flex-row-reverse pt-4 text-2xl leading-[1rem] text-white\"><div class=\"inline-block ml-2\"><a href=\"https://opensea.io/collection/laidback-lu\" target=\"_blank\" rel=\"noopener noreferrer\"><img class=\"w-6\" src=\"/images/logo-white.png\"></a></div><div class=\"inline-block ml-2\"><a href=\"https://discord.com/channels/1088335404014501908/1088335404014501911\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fab fa-brands fa-discord inline-flex\"></i></a></div><div class=\"inline-flex ml-2\"><a href=\"https://twitter.com/laidback_lu\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fab fa-brands fa-twitter\"></i></a></div></div>", 1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "h-24" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Languages = _resolveComponent("Languages")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("header.lu")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Languages, { classValue: "rounded p-1" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: _ctx.localizedUrl('/')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("header.home")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("header.pictureBook")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: _ctx.localizedUrl('/mint')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("header.shop")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _hoisted_13
      ])
    ]),
    _hoisted_14
  ], 64))
}